import { Component, Input } from '@angular/core';
import { WorkerAgreementDetailsDto } from '../../../models/dtos/worker-agreement-details-dto';
import { EmploymentAgreementDetailsDto } from '../../../models/dtos/employment-agreement-details-dto';
import { EmploymentType } from 'src/app/models/enums/employment-type-enum';

@Component({
  selector: 'app-agreement-details-tab',
  templateUrl: './agreement-details-tab.component.html',
  styleUrls: ['./agreement-details-tab.component.scss'],
  standalone: false,
})
export class AgreementDetailsTabComponent {
  @Input() agreement: WorkerAgreementDetailsDto | EmploymentAgreementDetailsDto;
  @Input() splitId: string;

  constructor() {}

  get isWorkerAgreement(): boolean {
    return (
      this.agreement.EmploymentTypeId === EmploymentType.MandateAgreement ||
      this.agreement.EmploymentTypeId === EmploymentType.TemporaryMandateAgreement
    );
  }

  get isEmploymentAgreement(): boolean {
    return (
      this.agreement.EmploymentTypeId === EmploymentType.EmploymentAgreement ||
      this.agreement.EmploymentTypeId === EmploymentType.TemporaryEmploymentAgreement
    );
  }

  get workerAgreement(): WorkerAgreementDetailsDto {
    return this.agreement as WorkerAgreementDetailsDto;
  }

  get employmentAgreement(): EmploymentAgreementDetailsDto {
    return this.agreement as EmploymentAgreementDetailsDto;
  }
}
